import filter from "lodash/filter";
import find from "lodash/find";
import get from "lodash/get";
import has from "lodash/has";
import sortBy from "lodash/sortBy";
import some from "lodash/some";

/**
 * Filter the users so we only show oncall people
 *
 * @param {Array} users
 * @return {Array} filtered users
 */
function filterUsersForOncall(users) {
  return users.filter(
    (user) =>
      user.dutiesQualifiedFor &&
      user.dutiesQualifiedFor.includes("oncall") &&
      !has(user, "archivedOn"),
  );
}

/**
 * Filter the users by the provided location
 *
 * @param {Array} users
 * @param {string} location (e.g. 'gh')
 * @return {Array} filtered users
 */
function filterUsersForLocation(users, location) {
  return users.filter(
    (user) => user.locations && user.locations.includes(location),
  );
}

/**
 * Returns a new array sorted alphabetically by display name
 *
 * @param {Array} rotaUser or coactive user collection
 * @return {Array}
 */
function sortUsersAlphabetically(users) {
  // n.b. don't use users.sort as that will modify the original array
  // work out if we're looking at rotausers, or coactive users:
  if (some(users, "displayName")) {
    return sortBy(users, ["displayName"]);
  }
  if (some(users, "profile.firstName")) {
    return sortBy(users, ["profile.firstName", "profile.lastName"]);
  }
  return users;
}

/**
 * Iterates over the rota assignments and checks to see if the user given
 * is currently assigned to any shifts
 *
 * @param {String} userId
 * @param {Object} rota
 * @return {boolean}
 */
function userIsOnThisRota(userId, rota) {
  if (!Array.isArray(rota.shifts) || rota.shifts.length === 0) {
    return false;
  }
  const currentShifts = filter(rota.shifts, (shift) =>
    find(get(shift, "assignedTo", []), { userId, type: "current" }),
  );
  return currentShifts.length > 0;
}

/**
 * Iterates over the rota assignments and checks to see if the agency given
 * is currently assigned to any shifts
 *
 * @param {String} userId
 * @param {Object} rota
 * @return {boolean}
 */
function agencyIsOnThisRota(agencyId, rota) {
  if (!Array.isArray(rota.shifts) || rota.shifts.length === 0) {
    return false;
  }
  const currentShifts = filter(rota.shifts, (shift) =>
    find(get(shift, "assignedTo", []), { agencyId, type: "current" }),
  );
  return currentShifts.length > 0;
}

export {
  filterUsersForOncall,
  filterUsersForLocation,
  sortUsersAlphabetically,
  userIsOnThisRota,
  agencyIsOnThisRota,
};
